import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import { CancelButton, SaveAndUpdate} from "../../utils/commonComponent/Custom/Button";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { DisciplineOptions } from "./disiplineConst";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";

const EditDisciplineMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Discipline Name *",
      stateKey: "name",
      options: DisciplineOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
      disabled: params.id != 0,
    },
    { type: "TextField", label: "Group *", stateKey: "groupName" },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchDisciplineDetails = async () => {
    try {
      const [discipline] = await fetchQuery(`select * from discipline where id = ${params.id}`);
      setInputStates(discipline);
    } catch (error) {
      console.error("Error fetching Discipline data:", error);
    }
  };

  const onSubmit = async () => {
    // show alert 
    const fieldsToValidate = [
      { value: inputStates.name, label: "Select Discipline Name" },
      { value: inputStates.groupName, label: "Enter Group Name" }
    ];
    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }
    try {
      const url = BASE_URL + `discipline`;
      const { unit_id, id, ...payload } = inputStates;
      params.id !== "0"
        ? await axiosWithToken.patch(url + `/${params.id}`, payload)
        : await axiosWithToken.post(url, payload);

      toast.success(
        params.id !== "0"
          ? "Discipline Updated Successfully!"
          : "Discipline Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/discipline"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchDisciplineDetails();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Discipline" : `Update Discipline `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
        <SaveAndUpdate
          id="btn-add-outline"
          label={params.id == 0 ? "Save" : "Update"}
          onClick={onSubmit}
        />
        )}
      </div>
    </div>
  );
};

export default EditDisciplineMaster;
